module.exports = __webpack_public_path__ + "static/media/man.6b69e395.svg";